/**
* @summary - Component that Provides Responded Details Edit for Vendor Work Order
* @author Yuvasri S
* @since 2024-09-11
*/
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import { BemsGraph, FemsGraph } from '../../utility/apiURLS';
import { format, previousDay } from 'date-fns';
import { updateothereRespondedDetails, updateRespondDetails } from '../../redux/actions/vendor/webFormActions';
import { useDispatch, useSelector } from 'react-redux';

const RespondedDetailsEditForm = ({ locationState, responseData }) => {

    const assetCategoryType = locationState?.serviceType || ""
    const categoryType = locationState?.categoryType;
    const serviceType = assetCategoryType === "FEMS" ? "fem" : "bem";
    const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
    const webFormData = useSelector((state) => state?.vendorWebForm);
    const [responseDetailsData, setResponseDetailsData] = useState(webFormData?.responseDetailsData);
    const dispatch = useDispatch();

    // Effect to set values from locationState
    useEffect(() => {
        if (responseData) {
            const getRepairtype = responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.[`${serviceType}worespondtype`]?.respondtype ? 
                                    responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.[`${serviceType}worespondtype`]?.respondtype : responseData?.[`${serviceType}worespondtype`] || ''
            const getRepairTypeID = getRepairtype === 'Outsource' ? 1 : 2; //to Set the repairTypeID
            const updatedResponseDetails = {
                respondedByID:responseData?.assessmentEmployeeId ? responseData?.assessmentEmployeeId : responseData?.scheduleEmployeeId || "",
                respondedBy: responseData?.assessmentEmployeename ? responseData?.assessmentEmployeename : responseData?.scheduleEmployeename || "",
                designation: responseData?.assessmentDesignation ? responseData?.assessmentDesignation : responseData?.scheduleDesignation || "",
                respondedStartDateandTime: responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.responsestartdate || '',
                respondedEndDateandTime: responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`][0]?.responseenddate || '',
                taskCode: `${responseData?.taskcode ? responseData?.taskcode : responseData?.scheduledTaskcode} - ${responseData?.taskdesc ? responseData?.taskdesc : responseData?.scheduledTaskdesc}`,
                taskDescription: responseData?.taskdesc ? responseData?.taskdesc : responseData?.scheduledTaskdesc || '',
                taskCodeID:responseData?.taskcodeId ? responseData?.taskcodeId : responseData?.scheduledTaskcodeId || "",
                repairType:getRepairtype,
                repairTypeID:getRepairTypeID,
                vendorID:responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.vendorid || responseData?.vendorId,
                timeStamp: responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.timestamp || ""
            };
            
            setResponseDetailsData((pre) => ({
                ...pre,
                ...updatedResponseDetails
            }));

            const workOrderNo = responseData?.workorderno || ""

            dispatch(updateRespondDetails("UPDATE_RESPONDED_DETAILS", { ...updatedResponseDetails, workOrderNo: workOrderNo }))
        }else{
            setResponseDetailsData(webFormData?.responseDetailsData);
        };
    }, [responseData]);

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }
        const formattedDate = format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss');
        return formattedDate;
    };

    const details = [
        { label: 'Responded By', value: responseDetailsData?.respondedBy || ""  },
        { label: 'Designation (Responder)', value: responseDetailsData?.designation || "" },
        { label: 'Respond Start Date', value: formatDate(responseDetailsData?.respondedStartDateandTime || "") },
        { label: 'Respond End Date', value: formatDate(responseDetailsData?.respondedEndDateandTime || "") },
        { label: 'Task Code & Description', value: responseDetailsData?.taskCode || "" },
        { label: 'Repair Type', value: responseDetailsData?.repairType || "" },
    ];

    return (
        <>
            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #EFEEF0',
                    borderRadius: '20px',
                    padding: '16px',
                }}
            >
                <Typography variant='title2'>
                    Responded Details
                </Typography>
                <Box mb={3} />
                <Grid container spacing={2}>
                    {details?.map((detail, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                            <Box>
                                <Typography variant="body2" sx={{ color: 'grey' }}>
                                    {detail?.label || ""}
                                </Typography>
                                <Typography variant="body1" fontWeight="bold">
                                    {detail?.value || ""}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </>
    );
};

export default React.memo(RespondedDetailsEditForm);

